<template>
    <div class="visitLog">
        <div class="info-top">访问记录</div>
        <div class="info-down"></div>
    </div>
</template>

<script>

export default {
    components: {
        
    },
    name: 'visitLog',
    data () {
        return {
        
        }
    }
}
</script>

<style lang="scss" scoped>
.visitLog{
    width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column;
    .info-top{
        height: 60px; width: 100%; margin-bottom: 16px; background: #ffffff; padding: 20px; line-height: 20px; border: 1px solid #e8e8e8;
    }
    .info-down{
        flex: 1; overflow: hidden; background: #ffffff; width: 100%; border: 1px solid #e8e8e8;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/visitLog.vue